var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1672 17.8373C15.5305 18.4752 14.6823 18.8262 13.781 18.8262C12.88 18.8262 12.0318 18.4752 11.395 17.8373L6.61377 13.0562C5.97602 12.4193 5.62501 11.5712 5.62501 10.67C5.62501 9.76879 5.97602 8.92072 6.61377 8.284C7.25049 7.64604 8.09876 7.29503 8.99998 7.29503C9.90098 7.29503 10.7493 7.64604 11.386 8.284L13.781 10.6778L20.3927 4.06632C18.2327 2.22476 15.436 1.10767 12.3749 1.10767C5.54055 1.10767 0 6.64822 0 13.4824C0 20.3168 5.54055 25.8573 12.3749 25.8573C19.2091 25.8573 24.7497 20.3168 24.7497 13.4824C24.7497 12.2034 24.5552 10.9703 24.1951 9.80937L16.1672 17.8373Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7809 16.5763C13.4929 16.5763 13.205 16.4661 12.9856 16.2467L8.20451 11.4654C7.76451 11.0256 7.76451 10.3145 8.20451 9.87476C8.6443 9.43476 9.35518 9.43476 9.79518 9.87476L13.7809 13.8605L25.0793 2.56227C25.5191 2.12247 26.23 2.12247 26.67 2.56227C27.1098 3.00226 27.1098 3.71314 26.67 4.15314L14.5762 16.2467C14.3571 16.4661 14.0689 16.5763 13.7809 16.5763Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.09bb81d708b915a67efb15813f7a5955.svg";
export { ForwardRef as ReactComponent };